module.exports = __webpack_public_path__ + "static/WEDDING E&M-177-4813672c65edc80477cfd9edc7b4f202.jpg";